
      const load_time = new Date().getTime();
      const backend = new URL(import.meta.env.VITE_APP_API_ENDPOINT, document.location).origin;

      // Which tenant's branding to ask for.
      //
      // The theme is fetched HERE, before React and long before anybody signs in, so the
      // server cannot work the tenant out from a logged-in user — it has to be told. The
      // slug is in the address on a tenant entry point (`/t/<slug>`), and it is remembered
      // because the address stops carrying it the moment the person signs in and lands on
      // their tray: without that, the app would be branded correctly on the login screen and
      // then revert to someone else's colours one navigation later.
      //
      // sessionStorage, not localStorage: two tenants opened in two tabs must not fight over
      // one value, and a closed tab should not decide how the next visit looks.
      const TENANT_KEY = 'uwe_tenant_entry';
      const fromPath = /^\/t\/([^/?#]+)/.exec(window.location.pathname);
      // `?tenant=` as well as the path, because a deep link from the Studio ("Go to
      // Project" pointed at a specific case) cannot also be a `/t/<slug>` entry point —
      // one is a door, the other is a destination — so the tenant travels as a parameter
      // on those.
      const fromQuery = new URLSearchParams(window.location.search).get('tenant');
      let tenant = fromPath ? decodeURIComponent(fromPath[1]) : (fromQuery || null);

      try {
        if (tenant) sessionStorage.setItem(TENANT_KEY, tenant);
        else tenant = sessionStorage.getItem(TENANT_KEY);
      } catch (e) {
        // Private windows and blocked site data throw here. The deployment-wide theme is a
        // perfectly good answer, so carry on unbranded rather than failing to paint at all.
      }

      // Still nothing? Then this may be a tenant's OWN address, which carries no slug
      // anywhere: no `/t/` segment, no parameter, and an empty sessionStorage on a hostname
      // visited for the first time.
      //
      // Asking the server costs one round trip, and it is paid BEFORE the favicon and the
      // theme on purpose. Those two are a `<link>` and a `fetch`, and only the fetch carries
      // an `Origin` the server could resolve the tenant from — a `<link>` carries none, and
      // this site's `same-origin` referrer policy strips the `Referer` on a cross-origin
      // request. So the server cannot work it out for the favicon no matter what it does: the
      // slug has to be in the URL, which means knowing it here.
      //
      // The empty string is a real answer and is stored as one: it means "already asked, this
      // host belongs to no tenant", so the plain entry point pays this round trip once per
      // session instead of on every page.
      if (tenant === null) {
        try {
          const response = await fetch(
            `${backend}/api/tenants/by-host?host=${encodeURIComponent(window.location.hostname)}`
          );
          tenant = response.ok ? ((await response.json())?.data?.slug || '') : '';
        } catch (e) {
          tenant = '';
        }

        try { sessionStorage.setItem(TENANT_KEY, tenant); } catch (e) { /* see above */ }
      }

      const tenantParam = tenant ? `&tenant=${encodeURIComponent(tenant)}` : '';

      (() => {
        const link = document.createElement('link');
        link.rel = 'shortcut icon';
        link.href = `${backend}/template-files/favicon.ico?lt=${load_time}${tenantParam}`;
        document.head.append(link);
      })();

      window.uwe_template = fetch(`${backend}/template-files/style.json?lt=${load_time}${tenantParam}`).then(r => r.json());
    